import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, adminOnly }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center text-sm text-[#525252]">
        <span className="inline-flex items-center gap-2">
          <Loader2 className="w-4 h-4 animate-spin" /> Loading…
        </span>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (!user.is_active) return <Navigate to="/pending" replace />;
  if (adminOnly && user.role !== "admin")
    return <Navigate to="/" replace />;
  return children;
}
